// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__21nCC","uiverse723":"Loader_uiverse723__bDZVX"};